import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/appSettings';
import { Payment, Site } from '../model/trip';

@Injectable()
export class TripService {
  readonly rootUrl = AppSettings.webApiURL; 

  constructor(public httpClient: HttpClient) { }

  public getSites() {
    return this.httpClient.get(`${this.rootUrl}/api/Trip/GetSites`);
  }

  public getCycles(siteId: number) {
    return this.httpClient.get(`${this.rootUrl}/api/Trip/GetCycles?siteId=${siteId}`);
  }

  // public getPayments(cycleId: number) {
  //   return this.httpClient.get(`${this.rootUrl}/api/Trip/GetPayments?cycleId=${cycleId}`);
  // }

  public getPayments2(siteId: number, selectedGrouperName: string, cycleId: number) {
    return this.httpClient.get(`${this.rootUrl}/api/Trip/GetPayments2?cycleId=${cycleId}&siteId=${siteId}&grouper=${selectedGrouperName}`);
  }

  // public charge(payments: Payment[], cycleId: number) {
  //   const headers = new HttpHeaders().set('content-type', 'application/json');
  //   return this.httpClient.post(`${this.rootUrl}/api/Trip/Charge?cycleId=${cycleId}`, payments, { headers });
  // }

  public charge2(payments: Payment[]) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/Trip/Charge2`, payments, { headers });
  }

  // public changeCardInit(payment: Payment, cId: number, sId: number, tId: number, statusId: number, grouper: string) {
  //   const headers = new HttpHeaders().set('content-type', 'application/json');
  //   return this.httpClient.post(`${this.rootUrl}/api/Trip/ChangeCardInit?cId=${cId}&sId=${sId}&tId=${tId}&statusId=${statusId}&grouper=${grouper}`, payment, { headers });
  // }

  public changeCardInit2(payment: Payment, cId: number, sId: number, catId: number, statusId: number, grouper: string) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/Trip/ChangeCardInit2?cId=${cId}&sId=${sId}&catId=${catId}&statusId=${statusId}&grouper=${grouper}`, payment, { headers });
  }

  // public changeCardCollect(pId: number, cId: number, sId: number, tId: number, statusId: number, grouper: string) {
  //   const headers = new HttpHeaders().set('content-type', 'application/json');
  //   return this.httpClient.post(`${this.rootUrl}/api/Trip/ChangeCardCollect?pId=${pId}&cId=${cId}&sId=${sId}&tId=${tId}&statusId=${statusId}&grouper=${grouper}`, null, { headers });
  // }

  public changeCardCollect2(pId: number, cId: number, sId: number, catId: number, statusId: number, grouper: string) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/Trip/ChangeCardCollect2?pId=${pId}&cId=${cId}&sId=${sId}&catId=${catId}&statusId=${statusId}&grouper=${grouper}`, null, { headers });
  }

  public changeNumOfPayments(payment: Payment, selectedNumOfPayments: number) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/Trip/changeNumOfPayments?sP=${selectedNumOfPayments}`, payment, { headers });
  }



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/service/trip.service.ts